import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

import { DefaultErrorFallback } from '@/components/ui/DefaultErrorFallback';

/**
 * Normalizes React Router's untyped route error into an `Error` for the
 * shared fallback UI.
 */
function toError(routeError: unknown): Error | undefined {
  if (routeError instanceof Error) {
    return routeError;
  }
  if (isRouteErrorResponse(routeError)) {
    return new Error(`${routeError.status} ${routeError.statusText}`);
  }
  if (typeof routeError === 'string') {
    return new Error(routeError);
  }
  return undefined;
}

/**
 * Router-level error boundary. Adapts `useRouteError()` to the shared
 * `DefaultErrorFallback` so render errors surface the branded fallback (which
 * renders inside MantineProvider) instead of React Router's raw crash page.
 * Reset performs a full reload to drop any stale module graph.
 */
export function RouteErrorElement() {
  const routeError = useRouteError();
  const error = toError(routeError);

  const handleReset = () => {
    window.location.reload();
  };

  return <DefaultErrorFallback error={error} onReset={handleReset} />;
}
